<div class="main">
<div style="min-height: 50vh; width: 100vw" *ngIf="isLoadingProfiles">
    <div class="loading-shade">
        <mat-spinner></mat-spinner>
    </div>
</div>

<table *ngIf="!isLoadingProfiles" mat-table [dataSource]="profiles" class="profiles-table">
    <ng-container matColumnDef="wellboreNo">
        <mat-header-cell *matHeaderCellDef> Wellbore </mat-header-cell>
        <mat-cell *matCellDef="let profile"> {{profile.wellboreNo}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="holeSize">
        <mat-header-cell *matHeaderCellDef> Diámetro de <br>Pozo [pulg] </mat-header-cell>
        <mat-cell *matCellDef="let profile; let i = index">
            <ng-container *ngIf="profile.obsHoleSize == ''">{{profile.holeSize}}</ng-container>
            <mat-form-field *ngIf="profile.obsHoleSize != ''">
                <input matInput type="number" [(ngModel)]="profiles[i].holeSize"
                    (keyup)="enableSaveButton(i, profiles[i].comments, holeSize.value); onSectionTouched('profiles')"
                    #holeSize  [disabled]="readOnlyContent"/>
                <mat-hint class="insecure" *ngIf="profile.obsHoleSize == '**'">
                    Dato dudoso. Verificar valor.
                </mat-hint>
                <mat-hint class="alert" *ngIf="profile.obsHoleSize == '*' && !profiles[i].holeSize">
                    Dato nulo. Verificar Valor.
                </mat-hint>
            </mat-form-field>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fecha">
        <mat-header-cell *matHeaderCellDef> Fecha </mat-header-cell>
        <mat-cell *matCellDef="let profile"> {{profile.fecha | date: 'dd/MM/yyyy'}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="jobType">
        <mat-header-cell *matHeaderCellDef> Tipo de perfil </mat-header-cell>
        <mat-cell *matCellDef="let profile"> {{profile.jobType}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="service">
        <mat-header-cell *matHeaderCellDef> Registro </mat-header-cell>
        <mat-cell *matCellDef="let profile">
            <mat-form-field>
                <input matInput type="text" value="{{profile.service}}" disabled />
                <mat-hint class="insecure" *ngIf="profile.servNoInLogType">
                    Debe validarse.
                </mat-hint>
            </mat-form-field>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="mdTop">
        <mat-header-cell *matHeaderCellDef> MD Tope <br>Intervalo [m] </mat-header-cell>
        <mat-cell *matCellDef="let profile"><span class="table-numbers-right-align"> {{profile.mdTop | number: '1.2-2'}} </span></mat-cell>
    </ng-container>

    <ng-container matColumnDef="mdBase">
        <mat-header-cell *matHeaderCellDef> MD Base <br>Intervalo [m] </mat-header-cell>
        <mat-cell *matCellDef="let profile"><span class="table-numbers-right-align"> {{profile.mdBase| number: '1.2-2'}} </span></mat-cell>
    </ng-container>


    <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let profile; let i = index" [ngClass]="'mat-column-save'">
            <span class="row-buttons">
                <button mat-mini-fab (click)="openComments(profiles[i], i, $event, readOnlyContent);" class="comment-ho-icon">
                    <mat-icon class="material-icons-outlined">chat_bubble_outline</mat-icon>
                    <div class="circle-comments" *ngIf="profiles[i].comments"></div>
                    <span class = "comment">Comentar</span>
            </button>
            </span>
            <button mat-mini-fab (click)="save(profile, i);" class="save-ho-icon" [disabled]="isDisabled[i]">
                <mat-icon class="material-icons-outlined">save</mat-icon>
            </button>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="noData">
        <mat-footer-cell *matFooterCellDef colspan="6">
            <div class="footer">
                <div class="footer-no-data">No se encontraron datos.</div>
                <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">De existir datos en el sistema de origen, podrás visualizarlos acá.</div>
            </div>
        </mat-footer-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide-footer':hideFooter}"></mat-footer-row>
</table>
</div>
